import { AcendexLayout } from "@/components/acendex/components/layout/AcendexLayout";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getText } from "../../utils/util";
import CenterPage from "./components/centerPage";

export default function HelpList() {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  return (
    <div className="min-h-screen bg-neutral-900 w-full">
      <AcendexLayout
        theme="light"
        mobileTopBarTitle={translate(getText("帮助中心"))}
        pcTopBarTitle={translate(getText("帮助中心"))}
        hideBottomBar
      >
        <div className="container mx-auto">
          <CenterPage />
        </div>
      </AcendexLayout>
    </div>
  );
}
